/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import plugin from 'tailwindcss/plugin';

export default plugin(function ({ addUtilities }) {
  addUtilities({
    '.display-saans-lg': {
      'font-size': '4rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '4.8rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.display-saans-md': {
      'font-size': '3.5rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '4.2rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.display-saans-sm': {
      'font-size': '3rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '3.6rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-3xl': {
      'font-size': '2.5rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '3.25rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-2xl': {
      'font-size': '2rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '2.6rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-xl': {
      'font-size': '1.75rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '2.275rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-lg': {
      'font-size': '1.5rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.95rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-md': {
      'font-size': '1.25rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.625rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-sm': {
      'font-size': '1.125rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.4625rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-xs': {
      'font-size': '1rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.3rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-2xs': {
      'font-size': '0.875rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.1375rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-saans-3xs': {
      'font-size': '0.75rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '530',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '0.975rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-xl-wide': {
      'font-size': '1.125rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '2.025rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-xl': {
      'font-size': '1.125rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.6875rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-lg': {
      'font-size': '1rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.5rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-md': {
      'font-size': '0.9375rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.5rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-sm': {
      'font-size': '0.875rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.3125rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-xs': {
      'font-size': '0.75rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.125rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-saans-2xs': {
      'font-size': '0.625rem',
      'text-decoration': 'none',
      'font-family': 'Saans',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '0.9375rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-inter-xl': {
      'font-size': '1.5rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '500',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.8rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-inter-lg': {
      'font-size': '1.25rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '500',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.5rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-inter-md': {
      'font-size': '1.125rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '500',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.35rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-inter-sm': {
      'font-size': '1rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '500',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.2rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-inter-xs': {
      'font-size': '0.875rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '500',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.05rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.title-inter-2xs': {
      'font-size': '0.75rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '500',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '0.9rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-inter-lg': {
      'font-size': '1rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.5rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-inter-md': {
      'font-size': '0.875rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.3125rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-inter-sm': {
      'font-size': '0.75rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.125rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.body-inter-xs': {
      'font-size': '0.625rem',
      'text-decoration': 'none',
      'font-family': 'InterVariable',
      'font-weight': '430',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '0.9375rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.mono-lg': {
      'font-size': '1rem',
      'text-decoration': 'none',
      'font-family': 'Geist Mono',
      'font-weight': '400',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.5rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.mono-md': {
      'font-size': '0.875rem',
      'text-decoration': 'none',
      'font-family': 'Geist Mono',
      'font-weight': '400',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.3125rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.mono-sm': {
      'font-size': '0.75rem',
      'text-decoration': 'none',
      'font-family': 'Geist Mono',
      'font-weight': '400',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '1.125rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
    '.mono-xs': {
      'font-size': '0.625rem',
      'text-decoration': 'none',
      'font-family': 'Geist Mono',
      'font-weight': '400',
      'font-style': 'normal',
      'font-stretch': 'normal',
      'letter-spacing': '0',
      'line-height': '0.9375rem',
      'paragraph-indent': '0',
      'paragraph-spacing': '0',
      'text-case': 'none',
    },
  });
});
